<template>
  <div>
    <anamnesis
      :dataCrud.sync="localDataCrud"
      :dataCrud2.sync="localDataCrud2"
      v-bind="{
        ...schema,
        handleEventsCrud,
        handleEvents,
        handleEvents2,
        clickRowInfo,
        clickRowInfo2,
        dataGroupsT,
        dataCodeT,
        checkboxDS,
        handleEventsbox,
        traceDiagBtn,
        save,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'DSxDetailsSymptomsPage',
  components: { Anamnesis },

  data: () => ({
    overlay: false,
    overlayMessage: '',
    localDataCrud: [],
    localDataCrud2: [],
  }),

  watch: {
    dataCrud: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud = JSON.parse(JSON.stringify(newValue));
        }
      }
    },
    dataCrud2: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud2 = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },

  computed: {
    ...mapGetters('anamDSxDetailsSymptoms', [
      'schema',
      'dataCrud',
      'dataCrud2',
      'dataGroupsT',
      'dataCodeT',
      'checkboxDS',
      'isNewRecord',
      'isNewRecordDS',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
  },

  methods: {
    ...mapActions('anamDSxDetailsSymptoms', [
      'fetchSchema',
      'fetchRecords',
      'updateRecord',
      'fetchRecordsTrace',
      'traceDiagCreate',
      'traceDiagUpdate',
    ]),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        this.snackbar.visible = false;
        this.snackbar.visible = true;
        this.snackbar.content = "Puede tardar unos segundos.";
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
          await this.fetchRecordsTrace();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    handleEventsbox(val) {
      this.$store.commit('anamDSxDetailsSymptoms/SET_RECORDS_TRACE', {
        recordsData: { 
          dataGroupsT: this.dataGroupsT,
          dataCodeT: this.dataCodeT,
          checkboxDS: val,
          isNewRecordDS: this.isNewRecordDS,
        }
      });
    },

    async save() {
      try {
        const model = { dataCrud: this.localDataCrud, dataCrud2: this.localDataCrud2 };
        const action = 'updateRecord';
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        const refreshBySave = 1;
        this.fetchRecords(refreshBySave);
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    async traceDiagBtn() {
      try {
        this.snackbar.visible = false;
        this.snackbar.visible = true;
        this.snackbar.content = 'Procesando, puede tardar unos segundos';

        const checkboxDS = this.checkboxDS;
        const action = this.isNewRecordDS ? 'traceDiagCreate' : 'traceDiagUpdate';
        await this[action]({ checkboxDS });

        if (this.status === 'success') {
          this.overlay = false;
          this.overlayMessage = '';
        }
        await this.fetchRecordsTrace();
      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackError || 'Error inesperado.'),
          'error'
        );
      }
    },

    handleEvents() {},

    handleEvents2() {},

    handleEventsCrud() {},

    clickRowInfo() {
    },

    clickRowInfo2() {
    },

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>
